export var ExprFrame;
(function (ExprFrame) {
    let Type;
    (function (Type) {
        Type["Cell"] = "CELL";
        Type["Pane"] = "PANE";
        Type["Table"] = "TABLE";
        Type["Custom"] = "CUSTOM";
    })(Type = ExprFrame.Type || (ExprFrame.Type = {}));
    /// Addressing
    let Address;
    (function (Address) {
        Address["Down"] = "DOWN";
        Address["Across"] = "ACROSS";
        Address["DownAcross"] = "DOWN_ACROSS";
        Address["AcrossDown"] = "ACROSS_DOWN";
    })(Address = ExprFrame.Address || (ExprFrame.Address = {}));
    let Cell;
    (function (Cell) {
        function make() {
            return { type: Type.Cell };
        }
        Cell.make = make;
    })(Cell = ExprFrame.Cell || (ExprFrame.Cell = {}));
    let Pane;
    (function (Pane) {
        function make(address = Address.Down) {
            return { address, type: Type.Pane };
        }
        Pane.make = make;
    })(Pane = ExprFrame.Pane || (ExprFrame.Pane = {}));
    let Table;
    (function (Table) {
        function make(address = Address.Down) {
            return { address, type: Type.Table };
        }
        Table.make = make;
    })(Table = ExprFrame.Table || (ExprFrame.Table = {}));
    let Custom;
    (function (Custom) {
        function make(address = []) {
            return { address, type: Type.Custom };
        }
        Custom.make = make;
    })(Custom = ExprFrame.Custom || (ExprFrame.Custom = {}));
    function equals(frame1, frame2) {
        // One or both frames are undefined
        if (!(frame1 && frame2)) {
            return frame1 == frame2;
        }
        // Frames have differing types
        if (frame1.type !== frame2.type) {
            return false;
        }
        switch (frame1.type) {
            case Type.Cell: {
                return true;
            }
            case Type.Pane:
            case Type.Table: {
                return frame1.address === frame2.address;
            }
            case Type.Custom: {
                const addrs1 = frame1.address;
                const addrs2 = frame2.address;
                return (addrs1.length === addrs2.length &&
                    addrs1.every((formula, index) => formula === addrs2[index]));
            }
        }
        return false;
    }
    ExprFrame.equals = equals;
})(ExprFrame || (ExprFrame = {}));
